module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (_vm.templateInstruction && _vm.templateInstruction.value && false) ? _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('pre', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.linkifyText(_vm.templateInstruction.value))),
      expression: "localeFtc(linkifyText(templateInstruction.value))"
    }],
    staticClass: "w5-normal-pre"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/reboot_button_header')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/reboot_button_description')),
      expression: "localeFtc('service/reboot_button_description')"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-submit tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || !_vm.Reboot
    },
    on: {
      "click": _vm.reboot
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "power-off"
    }
  }), _vm._v("\r\n\t\t\t" + _vm._s(_vm._f("ftc")('service/reboot')) + "\r\n\t\t")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/iso_button_header')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/iso_button_description')),
      expression: "localeFtc('service/iso_button_description')"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-submit tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || _vm.isISOProcessActive
    },
    on: {
      "click": _vm.operIso
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "compact-disc"
    }
  }), _vm._v(" "), (_vm.ISO && _vm.ISO.length) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('service/iso')))]) : _c('span', [_vm._v(_vm._s(_vm._f("ftc")('service/iso_insert')))])], 1), _vm._v(" "), (_vm.iso && _vm.iso.length) ? _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "line-height": "1.2"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")(_vm.iso[0] && _vm.iso[0]['service_name'] && _vm.iso[0]['service_name']['title'] ? _vm.iso[0]['service_name']['title'] : 'service/iso')) + ":")]), _vm._v(" "), _vm._l((_vm.iso), function(_iso, _idx) {
    return _c('span', {
      key: _iso && _iso.service_id && _iso.service_id.value ? _iso.service_id.value : _idx
    }, [(_idx > 0) ? _c('span', [_vm._v(",  ")]) : _vm._e(), _vm._v(" "), (_iso && _iso['service_status'] && _iso['service_status']['text']) ? _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [(_iso && _iso['service_name'] && _iso['service_name']['value']) ? _c('span', {
      staticStyle: {
        "color": "#333"
      }
    }, [_vm._v(_vm._s(_iso['service_name']['value']) + " ")]) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "src": require("../../assets/img/loading16.gif")
      }
    }), _vm._v(" " + _vm._s(_vm._f("lower")(_vm._f("ftc")(_iso['service_status']['text']))) + "\r\n\t\t\t\t")]) : (_iso && _iso['service_status'] && _iso['service_status']['value'] && _iso['service_status']['value'] !== 'active') ? _c('span', {
      class: 'w5-status-color-' + _iso['service_status']['value']
    }, [(_iso['service_status']['list'] && _iso['service_status']['list'][_iso['service_status']['value']]) ? [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_iso['service_status']['list'][_iso['service_status']['value']]))))] : [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_iso['service_status']['value']))))]], 2) : _c('linkComponent', {
      attrs: {
        "url": '/service/view/' + _iso['service_id']['value'],
        "text": _iso['service_name']['value']
      }
    })], 1)
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.canProlong) ? _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/prolong_button_header')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/prolong_button_description')),
      expression: "localeFtc('service/prolong_button_description')"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-submit tab-command-button",
    on: {
      "click": _vm.prolongVds
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "play-circle"
    }
  }), _vm._v("\r\n\t\t\t" + _vm._s(_vm._f("ftc")('service/prolong')) + "\r\n\t\t")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('div', {
    staticClass: "control-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoProlongValue),
      expression: "autoProlongValue"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoProlongValue) ? _vm._i(_vm.autoProlongValue, null) > -1 : (_vm.autoProlongValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.autoProlongValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.autoProlongValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.autoProlongValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoProlongValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || _vm.autoProlongProcessing
    },
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.autoProlongClick
    }
  }, [_vm._v("\r\n\t\t\t\t" + _vm._s(_vm._f("ftc")('service/autoprolong')) + "\r\n\t\t\t")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/autoprolong_off')),
      expression: "localeFtc('service/autoprolong_off')"
    }],
    staticClass: "warning-message"
  })]), _vm._v(" "), (_vm.canDelete) ? _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('div', {
    staticClass: "del-button-wrapper"
  }, [_c('div', {
    staticClass: "control-wrapper"
  }, [_c('div', {
    staticClass: "btn btn-submit-danger tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active'
    },
    on: {
      "click": _vm.deleteVds
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "trash-alt"
    }
  }), _vm._v("\r\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/delete_vds')) + "\r\n\t\t\t\t")], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "warning-message"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('main/attention')) + "!")]), _vm._v(" " + _vm._s(_vm._f("ftc")('service/vds_delete_warning')) + "!")])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRebootModal),
      expression: "showRebootModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRebootModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/reboot')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRebootModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.rebootModalText)),
      expression: "localeFtc(rebootModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rebootHardValue),
      expression: "rebootHardValue"
    }],
    staticClass: "w5-checkbox-field",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rebootHardValue) ? _vm._i(_vm.rebootHardValue, null) > -1 : (_vm.rebootHardValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rebootHardValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rebootHardValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rebootHardValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rebootHardValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.rebootHardClick
    }
  }, [_vm._v("\r\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/reboot_hard')) + "\r\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.rebootStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/reboot')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPasswordModal),
      expression: "showPasswordModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hidePasswordModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePasswordModal
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/password_change')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-weight-300 font-size-85 color-black"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.rebootWarning)))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.passwordWarning) ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.passwordWarning),
      expression: "passwordWarning"
    }],
    staticClass: "alert alert-warning font-size-90 margin-0 full-width"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.passwordField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": _vm.onFocusPassword,
      "enterKeyDown": _vm.passwordChange
    },
    model: {
      value: (_vm.passwordValue),
      callback: function($$v) {
        _vm.passwordValue = $$v
      },
      expression: "passwordValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.passwordChange
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/password_change')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/delete')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    class: {
      'flbx': _vm.Access && _vm.Status === 'active', 'r': _vm.reserveIpLocalData && _vm.Access && _vm.Status === 'active'
    }
  }, [(_vm.reserveIpLocalData && _vm.Access && _vm.Status === 'active') ? _c('div', {
    staticClass: "tab-pane-command-wrapper",
    staticStyle: {
      "margin": "0 0 15px",
      "padding": "5px 10px 10px 10px",
      "text-align": "initial"
    }
  }, [_c('div', {
    staticClass: "control-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reserveIpValue),
      expression: "reserveIpValue"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.reserveIpValue) ? _vm._i(_vm.reserveIpValue, null) > -1 : (_vm.reserveIpValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reserveIpValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reserveIpValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reserveIpValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.reserveIpValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || _vm.reserveIpProcessing || (_vm.deleteModalTimer && _vm.deleteModalTimer > 0)
    },
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.reserveIpStart
    }
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/save ippool/ippool')) + "\r\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', _vm.reserveIpCost)),
      expression: "localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', reserveIpCost)"
    }],
    staticClass: "warning-message",
    staticStyle: {
      "margin-bottom": "0",
      "font-size": "90%"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.reserveIpLocalData && _vm.Access && _vm.Status === 'active') ? _c('div', [_c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": require("../../assets/img/loading-hor16.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteStart
    }
  }, [_vm._v(_vm._s(_vm.modalDeleteButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModal),
      expression: "showConfirmModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.confirmModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConfirmModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.confirmModalText)),
      expression: "localeFtc(confirmModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.confirmModalTimer && _vm.confirmModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.confirmStart
    }
  }, [_vm._v(_vm._s(_vm.modalConfirmButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOperISOModal),
      expression: "showOperISOModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideOperISOModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/iso')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideOperISOModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [
    [_c('div', {
      staticClass: "w5-form-row"
    }, [_c('Field', {
      attrs: {
        "isVisibleRow": true,
        "crud": "vds",
        "action": "view",
        "Field": _vm.isoField1,
        "removeRightPadding": true,
        "fieldInModal": true,
        "listBlockToOut": 1
      },
      on: {
        "focus": _vm.onFocusIso,
        "enterKeyDown": _vm.operIsoBegin
      },
      model: {
        value: (_vm.isoValue1),
        callback: function($$v) {
          _vm.isoValue1 = $$v
        },
        expression: "isoValue1"
      }
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.ISO && _vm.ISO.length) || (_vm.isoValue1 !== null && _vm.isoValue1 > 0)),
        expression: "(ISO && ISO.length) || (isoValue1 !== null && isoValue1 > 0)"
      }],
      staticClass: "w5-form-row"
    }, [_c('Field', {
      attrs: {
        "isVisibleRow": true,
        "crud": "vds",
        "action": "view",
        "Field": _vm.isoField2,
        "removeRightPadding": true,
        "listBlockToOut": 1
      },
      on: {
        "focus": _vm.onFocusIso,
        "enterKeyDown": _vm.operIsoBegin
      },
      model: {
        value: (_vm.isoValue2),
        callback: function($$v) {
          _vm.isoValue2 = $$v
        },
        expression: "isoValue2"
      }
    })], 1)], _vm._v(" "), (_vm.operisoModalText) ? _c('p', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc(_vm.operisoModalText)),
        expression: "localeFtc(operisoModalText)"
      }],
      staticClass: "padding-0-5"
    }) : _vm._e()
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('urlButtonComponent', {
    staticClass: "pull-left",
    attrs: {
      "crud": "vds",
      "name": "create_iso",
      "url": '/iso/create',
      "text": 'service/iso_create'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit pull-right",
    class: {
      'btn-submit-danger': _vm.operisoModalButton === 'main/detach'
    },
    on: {
      "click": _vm.operIsoBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.operisoModalButton)))])], 1)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3664c30"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vds/command.vue
// module id = 556
// module chunks = 0